/**
 * iter134 — Tiny "Auto-approved by AI" chip for fund_transactions rows that
 * were approved by the Co-Admin AI. Hover shows the machine-readable
 * approval_reason so admins understand WHY the AI said yes.
 *
 * Renders nothing if the row was approved by a human, is pending, or is
 * legacy (no approval metadata).
 */
import { Sparkles, Clock } from 'lucide-react';

export default function AIApprovalChip({ txn, compact = false }) {
  if (!txn) return null;
  const status = txn.approval_status;
  const by = txn.approved_by;
  // Pending → amber clock chip
  if (status === 'pending') {
    return (
      <span
        className="inline-flex items-center gap-0.5 text-xs uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-amber-500/15 text-amber-700 dark:text-amber-300 font-bold"
        data-testid={`pending-chip-${txn.id}`}
        title={txn.approval_reason || 'Awaiting co-approval'}
      >
        <Clock className="w-2.5 h-2.5" />
        {compact ? '' : 'Pending'}
      </span>
    );
  }
  // AI-approved
  if (by === 'co_admin_ai') {
    return (
      <span
        className="inline-flex items-center gap-0.5 text-xs uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-violet-500/15 text-violet-700 dark:text-violet-300 font-bold cursor-help"
        data-testid={`ai-approved-chip-${txn.id}`}
        title={txn.approval_reason || 'Auto-approved by Co-Admin AI'}
      >
        <Sparkles className="w-2.5 h-2.5" />
        {compact ? 'AI' : 'AI approved'}
      </span>
    );
  }
  return null;
}
